import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import { ECoachingChatSeedQuestionFormField } from "../types"

const resolver: ReturnType<typeof yupResolver> = yupResolver(
    yup
        .object()
        .shape({
            [ECoachingChatSeedQuestionFormField.Answer]: yup.string().nullable().notRequired().max(5047),
            [ECoachingChatSeedQuestionFormField.Question]: yup.string().notRequired(),
            [ECoachingChatSeedQuestionFormField.Id]: yup.string().notRequired(),
            [ECoachingChatSeedQuestionFormField.Index]: yup.number().notRequired()
        })
        .strict(true)
        .noUnknown(true)
)

export { resolver as coachingChatSeedQuestionFormResolver }
